import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

const CheckboxComponent = ({ checkbox = {} }) => {
  const { hoveredDivision, files } = useContext(CanvasContext);
  const [isChecked, setIsChecked] = useState(checkbox.checked || false);

  const handleCheckboxChange = (checked) => {
    setIsChecked(checked); // Update the checked state
  };

  const isHovered = checkbox.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState(null);
  const [backgroundImagelabelUrl, setlabelbackgroundImagelabelUrl] =
    useState(null);

  const constructGradientString = () => {
    const {
      backgroundGradientImage,
      gradientDirection,
      gradientShape,
      gradientPosition,
      startColor,
      endColor,
      gradientAngle,
      patternLength,
    } = checkbox;

    switch (backgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${gradientDirection || "to right"}, ${
          startColor || "#ff7e5f"
        }, ${endColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${gradientAngle || "45"}deg, ${
          startColor || "#606dbc"
        }, ${endColor || "#465298"} ${patternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${gradientShape || "circle"} at ${
          gradientPosition || "center"
        }, ${startColor || "#ff7e5f"}, ${endColor || "#feb47b"} ${
          patternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };
  const labelconstructGradientString = () => {
    const {
      labelbackgroundGradientImage,
      labelgradientDirection,
      labelgradientShape,
      labelgradientPosition,
      labelstartColor,
      labelendColor,
      labelgradientAngle,
      labelpatternLength,
    } = checkbox;

    switch (labelbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${labelgradientDirection || "to right"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${labelgradientShape || "circle"} at ${
          labelgradientPosition || "center"
        }, ${labelstartColor || "#ff7e5f"}, ${labelendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${labelgradientAngle || "45"}deg, ${
          labelstartColor || "#606dbc"
        }, ${labelendColor || "#465298"} ${labelpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          labelgradientShape || "circle"
        } at ${labelgradientPosition || "center"}, ${
          labelstartColor || "#ff7e5f"
        }, ${labelendColor || "#feb47b"} ${labelpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructHoverGradientString = () => {
    const {
      hoveredbackgroundGradientImage,
      hoveredgradientDirection,
      hoveredgradientShape,
      hoveredgradientPosition,
      hoveredstartColor,
      hoveredendColor,
      hoveredgradientAngle,
      hoveredpatternLength,
    } = checkbox;

    switch (hoveredbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${hoveredgradientDirection || "to right"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${hoveredgradientShape || "circle"} at ${
          hoveredgradientPosition || "center"
        }, ${hoveredstartColor || "#ff7e5f"}, ${hoveredendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${hoveredgradientAngle || "45"}deg, ${
          hoveredstartColor || "#606dbc"
        }, ${hoveredendColor || "#465298"} ${hoveredpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          hoveredgradientShape || "circle"
        } at ${hoveredgradientPosition || "center"}, ${
          hoveredstartColor || "#ff7e5f"
        }, ${hoveredendColor || "#feb47b"} ${hoveredpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructFocusedGradientString = () => {
    const {
      focusedbackgroundGradientImage,
      focusedgradientDirection,
      focusedgradientShape,
      focusedgradientPosition,
      focusedstartColor,
      focusedendColor,
      focusedgradientAngle,
      focusedpatternLength,
    } = checkbox;

    switch (focusedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${focusedgradientDirection || "to right"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${focusedgradientShape || "circle"} at ${
          focusedgradientPosition || "center"
        }, ${focusedstartColor || "#ff7e5f"}, ${focusedendColor || "#feb47b"})`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${focusedgradientAngle || "45"}deg, ${
          focusedstartColor || "#606dbc"
        }, ${focusedendColor || "#465298"} ${focusedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          focusedgradientShape || "circle"
        } at ${focusedgradientPosition || "center"}, ${
          focusedstartColor || "#ff7e5f"
        }, ${focusedendColor || "#feb47b"} ${focusedpatternLength || "10"}%)`;

      default:
        return "none";
    }
  };
  const constructActivatedGradientString = () => {
    const {
      activatedbackgroundGradientImage,
      activatedgradientDirection,
      activatedgradientShape,
      activatedgradientPosition,
      activatedstartColor,
      activatedendColor,
      activatedgradientAngle,
      activatedpatternLength,
    } = checkbox;

    switch (activatedbackgroundGradientImage) {
      case "linear-gradient":
        return `linear-gradient(${activatedgradientDirection || "to right"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"})`;

      case "radial-gradient":
        return `radial-gradient(${activatedgradientShape || "circle"} at ${
          activatedgradientPosition || "center"
        }, ${activatedstartColor || "#ff7e5f"}, ${
          activatedendColor || "#feb47b"
        })`;

      case "repeating-linear-gradient":
        return `repeating-linear-gradient(${
          activatedgradientAngle || "45"
        }deg, ${activatedstartColor || "#606dbc"}, ${
          activatedendColor || "#465298"
        } ${activatedpatternLength || "10"}px)`;

      case "repeating-radial-gradient":
        return `repeating-radial-gradient(${
          activatedgradientShape || "circle"
        } at ${activatedgradientPosition || "center"}, ${
          activatedstartColor || "#ff7e5f"
        }, ${activatedendColor || "#feb47b"} ${
          activatedpatternLength || "10"
        }%)`;

      default:
        return "none";
    }
  };

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      if (
        checkbox.backgroundImage &&
        checkbox.backgroundImage.startsWith("./")
      ) {
        const imageName = checkbox.backgroundImage.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setBackgroundImageUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setBackgroundImageUrl(checkbox.backgroundImage);
      }
    };

    fetchBackgroundImage();
  }, [checkbox.backgroundImage, files]);

  useEffect(() => {
    const fetchlabelbackgroundImagelabel = async () => {
      if (
        checkbox.labelbackgroundImagelabel &&
        checkbox.labelbackgroundImagelabel.startsWith("./")
      ) {
        const imageName = checkbox.labelbackgroundImagelabel.replace("./", "");
        const file = files.find((f) => f.name === imageName);
        if (file && file.data) {
          setlabelbackgroundImagelabelUrl(file.data);
        } else {
          console.error("Image not found in files:", imageName);
        }
      } else {
        setlabelbackgroundImagelabelUrl(checkbox.labelbackgroundImagelabel);
      }
    };

    fetchlabelbackgroundImagelabel();
  }, [checkbox.labelbackgroundImagelabel, files]);

  const focusedStyles =
    isDivFocused && checkbox.pseudoClass === "focus"
      ? {
          // width: checkbox.focusedwidth || checkbox.width || "auto",
          // height: checkbox.focusedheight || checkbox.height || "auto",

          padding: checkbox.focusedpadding || checkbox.padding || "0",
          paddingTop:
            checkbox.focusedpaddingTop || checkbox.focusedpadding || "0",
          paddingRight:
            checkbox.focusedpaddingRight || checkbox.focusedpadding || "3px",
          paddingBottom:
            checkbox.focusedpaddingBottom || checkbox.focusedpadding || "0",
          paddingLeft:
            checkbox.focusedpaddingLeft || checkbox.focusedpadding || "3px",
          margin: checkbox.focusedmargin || checkbox.margin || "0px",
          marginTop:
            checkbox.focusedmarginTop || checkbox.focusedmargin || "0px",
          marginRight:
            checkbox.focusedmarginRight || checkbox.focusedmargin || "0px",
          marginBottom:
            checkbox.focusedmarginBottom || checkbox.focusedmargin || "0px",
          marginLeft:
            checkbox.focusedmarginLeft || checkbox.focusedmargin || "0px",

          borderTop:
            checkbox.focusedborderTop ||
            checkbox.focusedborder ||
            checkbox.border ||
            "none",
          borderRight:
            checkbox.focusedborderRight ||
            checkbox.focusedborder ||
            checkbox.border ||
            "none",
          borderBottom:
            checkbox.focusedborderBottom ||
            checkbox.focusedborder ||
            checkbox.border ||
            "none",
          borderLeft:
            checkbox.focusedborderLeft ||
            checkbox.focusedborder ||
            checkbox.border ||
            "none",
          borderSapcing:
            checkbox.focusedborderSpacing || checkbox.borderSpacing || "0px",
          borderCollapse:
            checkbox.focusedborderCollapse || checkbox.borderCollapse || "0px",
          borderRadius:
            checkbox.focusedborderRadius || checkbox.borderRadius || "0",
          outline: checkbox.focusedoutline || checkbox.outline || "none",

          position: checkbox.focusedposition || checkbox.position || "relative",
          top: checkbox.focusedtop || checkbox.top || "auto",
          right: checkbox.focusedright || checkbox.right || "auto",
          bottom: checkbox.focusedbottom || checkbox.bottom || "auto",
          left: checkbox.focusedleft || checkbox.left || "auto",
          zIndex: checkbox.focusedzIndex || checkbox.zIndex || "auto",

          color: checkbox.focusedcolor || checkbox.color || "#000000",
          backgroundColor:
            checkbox.focusedbackgroundColor ||
            checkbox.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (checkbox.focusedbackgroundImage) {
              if (checkbox.focusedbackgroundImage.startsWith("./")) {
                const imageName = checkbox.focusedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${checkbox.focusedbackgroundImage})`;
            }
            if (checkbox.backgroundImage) {
              if (checkbox.backgroundImage.startsWith("./")) {
                const imageName = checkbox.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${checkbox.backgroundImage})`;
            }
            return (
              constructFocusedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            checkbox.focusedbackgroundPosition ||
            checkbox.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            checkbox.focusedbackgroundSize || checkbox.backgroundSize || "auto",
          backgroundRepeat:
            checkbox.focusedbackgroundRepeat ||
            checkbox.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            checkbox.focusedbackgroundAttachment ||
            checkbox.backgroundAttachment ||
            "scroll",

          boxShadow: checkbox.focusedboxShadow || checkbox.boxShadow || "none",
          opacity: checkbox.focusedOpacity || checkbox.opacity || 1,
          display: checkbox.focuseddisplay || checkbox.display || "inline",

          cursor: checkbox.focusedcursor || checkbox.cursor || "default",
          transform: checkbox.focusedtransform || checkbox.transform || "none",
          transition:
            checkbox.focusedtransition || checkbox.transition || "none",
        }
      : {};
  const hoverStyles =
    isDivHovered && checkbox.pseudoClass === "hover"
      ? {
          // width: checkbox.hoveredwidth || checkbox.width || "auto",
          // height: checkbox.hoveredheight || checkbox.height || "auto",

          padding: checkbox.hoveredpadding || checkbox.padding || "0",
          paddingTop:
            checkbox.hoveredpaddingTop || checkbox.hoveredpadding || "0",
          paddingRight:
            checkbox.hoveredpaddingRight || checkbox.hoveredpadding || "3px",
          paddingBottom:
            checkbox.hoveredpaddingBottom || checkbox.hoveredpadding || "0",
          paddingLeft:
            checkbox.hoveredpaddingLeft || checkbox.hoveredpadding || "3px",
          margin: checkbox.hoveredmargin || checkbox.margin || "0px",
          marginTop:
            checkbox.hoveredmarginTop || checkbox.hoveredmargin || "0px",
          marginRight:
            checkbox.hoveredmarginRight || checkbox.hoveredmargin || "0px",
          marginBottom:
            checkbox.hoveredmarginBottom || checkbox.hoveredmargin || "0px",
          marginLeft:
            checkbox.hoveredmarginLeft || checkbox.hoveredmargin || "0px",

          borderTop:
            checkbox.hoveredborderTop ||
            checkbox.hoveredborder ||
            checkbox.border ||
            "none",
          borderRight:
            checkbox.hoveredborderRight ||
            checkbox.hoveredborder ||
            checkbox.border ||
            "none",
          borderBottom:
            checkbox.hoveredborderBottom ||
            checkbox.hoveredborder ||
            checkbox.border ||
            "none",
          borderLeft:
            checkbox.hoveredborderLeft ||
            checkbox.hoveredborder ||
            checkbox.border ||
            "none",
          borderSapcing:
            checkbox.hoveredborderSpacing || checkbox.borderSpacing || "0px",
          borderCollapse:
            checkbox.hoveredborderCollapse || checkbox.borderCollapse || "0px",
          borderRadius:
            checkbox.hoveredborderRadius || checkbox.borderRadius || "0",
          outline: checkbox.hoveredoutline || checkbox.outline || "none",

          position: checkbox.hoveredposition || checkbox.position || "relative",
          top: checkbox.hoveredtop || checkbox.top || "auto",
          right: checkbox.hoveredright || checkbox.right || "auto",
          bottom: checkbox.hoveredbottom || checkbox.bottom || "auto",
          left: checkbox.hoveredleft || checkbox.left || "auto",
          zIndex: checkbox.hoveredzIndex || checkbox.zIndex || "auto",

          color: checkbox.hoveredcolor || checkbox.color || "#000000",
          backgroundColor:
            checkbox.hoveredbackgroundColor ||
            checkbox.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (checkbox.hoveredbackgroundImage) {
              if (checkbox.hoveredbackgroundImage.startsWith("./")) {
                const imageName = checkbox.hoveredbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${checkbox.hoveredbackgroundImage})`;
            }
            if (checkbox.backgroundImage) {
              if (checkbox.backgroundImage.startsWith("./")) {
                const imageName = checkbox.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${checkbox.backgroundImage})`;
            }
            return (
              constructHoverGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            checkbox.hoveredbackgroundPosition ||
            checkbox.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            checkbox.hoveredbackgroundSize || checkbox.backgroundSize || "auto",
          backgroundRepeat:
            checkbox.hoveredbackgroundRepeat ||
            checkbox.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            checkbox.hoveredbackgroundAttachment ||
            checkbox.backgroundAttachment ||
            "scroll",

          boxShadow: checkbox.hoveredboxShadow || checkbox.boxShadow || "none",
          opacity: checkbox.hoveredOpacity || checkbox.opacity || 1,
          display: checkbox.hovereddisplay || checkbox.display || "inline",

          cursor: checkbox.hoveredcursor || checkbox.cursor || "default",
          transform: checkbox.hoveredtransform || checkbox.transform || "none",
          transition:
            checkbox.hoveredtransition || checkbox.transition || "none",
        }
      : {};
  const activeStyles =
    isDivActive && checkbox.pseudoClass === "active"
      ? {
          // width: checkbox.activatedwidth || checkbox.width || "200px",
          // height: checkbox.activatedheight || checkbox.height || "auto",

          padding: checkbox.activatedpadding || checkbox.padding || "0",
          paddingTop:
            checkbox.activatedpaddingTop || checkbox.activatedpadding || "0",
          paddingRight:
            checkbox.activatedpaddingRight ||
            checkbox.activatedpadding ||
            "3px",
          paddingBottom:
            checkbox.activatedpaddingBottom || checkbox.activatedpadding || "0",
          paddingLeft:
            checkbox.activatedpaddingLeft || checkbox.activatedpadding || "3px",
          margin: checkbox.activatedmargin || checkbox.margin || "0px",
          marginTop:
            checkbox.activatedmarginTop || checkbox.activatedmargin || "0px",
          marginRight:
            checkbox.activatedmarginRight || checkbox.activatedmargin || "0px",
          marginBottom:
            checkbox.activatedmarginBottom || checkbox.activatedmargin || "0px",
          marginLeft:
            checkbox.activatedmarginLeft || checkbox.activatedmargin || "0px",

          borderTop:
            checkbox.activatedborderTop ||
            checkbox.activatedborder ||
            checkbox.border ||
            "none",
          borderRight:
            checkbox.activatedborderRight ||
            checkbox.activatedborder ||
            checkbox.border ||
            "none",
          borderBottom:
            checkbox.activatedborderBottom ||
            checkbox.activatedborder ||
            checkbox.border ||
            "none",
          borderLeft:
            checkbox.activatedborderLeft ||
            checkbox.activatedborder ||
            checkbox.border ||
            "none",
          borderSapcing:
            checkbox.activatedborderSpacing || checkbox.borderSpacing || "0px",
          borderCollapse:
            checkbox.activatedborderCollapse ||
            checkbox.borderCollapse ||
            "0px",
          borderRadius:
            checkbox.activatedborderRadius || checkbox.borderRadius || "0",
          outline: checkbox.activatedoutline || checkbox.outline || "none",

          position:
            checkbox.activatedposition || checkbox.position || "relative",
          top: checkbox.activatedtop || checkbox.top || "auto",
          right: checkbox.activatedright || checkbox.right || "auto",
          bottom: checkbox.activatedbottom || checkbox.bottom || "auto",
          left: checkbox.activatedleft || checkbox.left || "auto",
          zIndex: checkbox.activatedzIndex || checkbox.zIndex || "auto",

          color: checkbox.activatedcolor || checkbox.color || "#000000",
          backgroundColor:
            checkbox.activatedbackgroundColor ||
            checkbox.backgroundColor ||
            "#ffffff",
          backgroundImage: (() => {
            if (checkbox.activatedbackgroundImage) {
              if (checkbox.activatedbackgroundImage.startsWith("./")) {
                const imageName = checkbox.activatedbackgroundImage.replace(
                  "./",
                  ""
                );
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${checkbox.activatedbackgroundImage})`;
            }
            if (checkbox.backgroundImage) {
              if (checkbox.backgroundImage.startsWith("./")) {
                const imageName = checkbox.backgroundImage.replace("./", "");
                const file = files.find((f) => f.name === imageName);
                return file && file.data ? `url(${file.data})` : "none";
              }
              return `url(${checkbox.backgroundImage})`;
            }
            return (
              constructActivatedGradientString() ||
              constructGradientString() ||
              "none"
            );
          })(),
          backgroundPosition:
            checkbox.activatedbackgroundPosition ||
            checkbox.backgroundPosition ||
            "0% 0%",
          backgroundSize:
            checkbox.activatedbackgroundSize ||
            checkbox.backgroundSize ||
            "auto",
          backgroundRepeat:
            checkbox.activatedbackgroundRepeat ||
            checkbox.backgroundRepeat ||
            "repeat",
          backgroundAttachment:
            checkbox.activatedbackgroundAttachment ||
            checkbox.backgroundAttachment ||
            "scroll",

          boxShadow:
            checkbox.activatedboxShadow || checkbox.boxShadow || "none",
          opacity: checkbox.activatedOpacity || checkbox.opacity || 1,
          display: checkbox.activateddisplay || checkbox.display || "inline",

          cursor: checkbox.activatedcursor || checkbox.cursor || "default",
          transform:
            checkbox.activatedtransform || checkbox.transform || "none",
          transition:
            checkbox.activatedtransition || checkbox.transition || "none",
        }
      : {};

  const inputStyle = {
    width: checkbox.width || "auto",
    height: checkbox.height || "auto",

    margin: checkbox.margin || "0px",
    marginTop: checkbox.marginTop || checkbox.margin || "0",
    marginRight: checkbox.marginRight || checkbox.margin || "0px",
    marginBottom: checkbox.marginBottom || checkbox.margin || "0",
    marginLeft: checkbox.marginLeft || checkbox.margin || "0px",
    padding: checkbox.padding || "0px",
    paddingTop: checkbox.paddingTop || checkbox.padding || "0px",
    paddingRight: checkbox.paddingRight || checkbox.padding || "3px",
    paddingBottom: checkbox.paddingBottom || checkbox.padding || "0px",
    paddingLeft: checkbox.paddingLeft || checkbox.padding || "3px",

    borderTop: isHovered
      ? "1px dashed #555"
      : checkbox.borderTop || checkbox.border || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : checkbox.borderRight || checkbox.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : checkbox.borderBottom || checkbox.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : checkbox.borderLeft || checkbox.border || "none",

    borderSapcing: checkbox.borderSpacing || "0px",
    borderCollapse: checkbox.borderCollapse || "0px",
    borderRadius: checkbox.borderRadius || "0",
    outline: checkbox.outline || "none",

    position: checkbox.position || "static",
    top: checkbox.top || "auto",
    right: checkbox.right || "auto",
    bottom: checkbox.bottom || "auto",
    left: checkbox.left || "auto",
    zIndex: checkbox.zIndex || "auto",

    color: checkbox.color || "#000000",
    backgroundColor: checkbox.backgroundColor || "#ffffff",
    backgroundImage: backgroundImageUrl
      ? `url(${backgroundImageUrl})`
      : constructGradientString(),
    backgroundPosition:
      checkbox.focusedbackgroundPosition ||
      checkbox.backgroundPosition ||
      "0% 0%",
    backgroundSize:
      checkbox.focusedbackgroundSize || checkbox.backgroundSize || "auto",
    backgroundRepeat:
      checkbox.focusedbackgroundRepeat || checkbox.backgroundRepeat || "repeat",
    backgroundAttachment:
      checkbox.focusedbackgroundAttachment ||
      checkbox.backgroundAttachment ||
      "scroll",

    opacity: checkbox.opacity || "1",
    display: checkbox.display || "inline",
    cursor: checkbox.cursor || "auto",

    transform: checkbox.transform || "none",
    transition: checkbox.transition || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  const labelStyle = {
    margin: checkbox.labelmargin || "0px",
    marginTop: checkbox.labelmarginTop || checkbox.labelmargin || "0",
    marginRight: checkbox.labelmarginRight || checkbox.labelmargin || "10px",
    marginBottom: checkbox.labelmarginBottom || checkbox.labelmargin || "0",
    marginLeft: checkbox.labelmarginLeft || checkbox.labelmargin || "10px",
    padding: checkbox.labelpadding || "0px",
    paddingTop: checkbox.labelpaddingTop || checkbox.labelpadding || "0",
    paddingRight: checkbox.labelpaddingRight || checkbox.labelpadding || "0",
    paddingBottom: checkbox.labelpaddingBottom || checkbox.labelpadding || "0",
    paddingLeft: checkbox.labelpaddingLeft || checkbox.labelpadding || "0",

    borderTop: isHovered
      ? "1px dashed #555"
      : checkbox.labelborderTop || checkbox.labelborder || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : checkbox.labelborderRight || checkbox.labelborder || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : checkbox.labelborderBottom || checkbox.labelborder || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : checkbox.labelborderLeft || checkbox.labelborder || "none",

    borderSapcing: checkbox.labelborderSpacing || "0px",
    borderCollapse: checkbox.labelborderCollapse || "0px",
    borderRadius: checkbox.labelborderRadius || "0",
    outline: checkbox.labeloutline || "none",

    position: checkbox.labelposition || "static",
    top: checkbox.labeltop || "auto",
    right: checkbox.labelright || "auto",
    bottom: checkbox.labelbottom || "auto",
    left: checkbox.labelleft || "auto",
    zIndex: checkbox.labelzIndex || "auto",

    color: checkbox.labelcolor || "#000000",
    backgroundColor: checkbox.labelbackgroundColor || "#ffffff",
    backgroundImage: backgroundImagelabelUrl
      ? `url(${backgroundImagelabelUrl})`
      : labelconstructGradientString(),
    backgroundPosition:
      checkbox.labelbackgroundPosition ||
      checkbox.labelbackgroundPosition ||
      "0% 0%",
    backgroundSize:
      checkbox.labelbackgroundSize || checkbox.labelbackgroundSize || "auto",
    backgroundRepeat:
      checkbox.labelbackgroundRepeat ||
      checkbox.labelbackgroundRepeat ||
      "repeat",
    backgroundAttachment:
      checkbox.labelbackgroundAttachment ||
      checkbox.labelbackgroundAttachment ||
      "scroll",

    fontSize: checkbox.labelfontSize || "inherit",
    fontFamily: checkbox.labelfontFamily || "inherit",
    fontWeight: checkbox.labelfontWeight || "normal",
    fontStyle: checkbox.labelfontStyle || "normal",
    fontVariant: checkbox.labelfontVariant || "normal",
    lineHeight: checkbox.labellineHeight || "normal",
    textAlign: checkbox.labeltextAlign || "left",
    textDecoration: checkbox.labeltextDecoration || "none",
    textTransform: checkbox.labeltextTransform || "none",
    textShadow: checkbox.labeltextShadow || "none",
    verticalAlign: checkbox.labelverticalAlign || "baseline",
    letterSpacing: checkbox.labelletterSpacing || "normal",
    wordSpacing: checkbox.labelwordSpacing || "normal",
    textIndent: checkbox.labeltextIndent || "0",
    whiteSpace: checkbox.labelwhiteSpace || "normal",
    textOverflow: checkbox.labeltextOverflow || "clip",
    direction: checkbox.labeldirection || "ltr",
    unicodeBidi: checkbox.labelunicodeBidi || "normal",
    writingMode: checkbox.labelwritingMode || "horizontal-tb",

    opacity: checkbox.labelopacity || "1",
    display: checkbox.display || "inline",
    cursor: checkbox.cursor || "auto",

    transform: checkbox.transform || "none",
    transition: checkbox.transition || "none",
  };

  return (
    <>
      <input
        type="checkbox"
        checked={isChecked}
        disabled={checkbox.disabled || false}
        required={checkbox.required || true}
        name={checkbox.name || ""}
        value={checkbox.value || ""}
        id={checkbox.id || ""}
        form={checkbox.form || ""}
        style={inputStyle}
        onMouseEnter={() => setIsDivHovered(true)}
        onMouseLeave={() => setIsDivHovered(false)}
        onFocus={() => setIsDivFocused(true)}
        onBlur={() => setIsDivFocused(false)}
        onMouseDown={() => setIsDivActive(true)}
        onMouseUp={() => setIsDivActive(false)}
        onChange={(e) => handleCheckboxChange(e.target.checked)}
      />
      <label style={labelStyle}>{checkbox.label || "checkbox"}</label>
    </>
  );
};

export default CheckboxComponent;
